
export type Item = { field: string, value: string | React.ReactNode, extra?: Item }

interface IContentBoxProps {
  label: string;
  content: Item[]
}

export const ContentBox: React.FC<IContentBoxProps> = (props) => {
  const { label, content } = props;

  return (
    <div className='content-box'>
      <div className='label'>
        {label}
      </div>
      <div className='content'>
        {
          content.map(({ field, value, extra }, index) => (
            <div key={index} className='item'>
              <div className='item-row'>
                <div className='field'>{field}</div>
                <div className='value'>{value}</div>
              </div>
              {
                extra &&
                <div className='item-row extra'>
                  <div className='field'>{extra.field}</div>
                  <div className='value'>{extra.value}</div>
                </div>
              }
            </div>
          ))
        }
      </div>
    </div>
  );
};